module.exports = __webpack_public_path__ + "img/matomo_logo_white.274b1877.png";